import {componentOptions, reduxList} from '../../../comments/redux/userSubscriptions';
import {FilterInput} from '../../../components/lists/FilterInput';
import {ReduxListFilterStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';


export const UserViewChannelsFilter = ReduxListFilterStreamedContainer(FilterInput, reduxList, componentOptions);



// WEBPACK FOOTER //
// ./src/js/user/components/UserViewChannels/UserViewChannelsFilter.js